import React from 'react';
import MainTopRankings from '../../components/MainTopRankings';
// import WeeklyTopFiveComplexCard from '../../components/WeeklyTopFiveComplexCard'; // 임시 숨김
import RankerComplexShortcutCard from '../../components/RankerComplexShortcutCard';
import ComplexCompareShortcutCard from '../../components/ComplexCompareShortcutCard';
import KbTrendComboChart from '../../components/KbTrendComboChart';
import KbTopIndexChart from '../../components/KbTopIndexChart';
import KbStatusBoardStrip from '../../components/KbStatusBoardStrip';
import './RankingPage.css';

function RankingPage() {
  return (
    <div className="ranking-page">
      <div className="ranking-content">
        <main className="ranking-main">
          {/* 최상단: KB 주간/월간 지표 요약 스트립 */}
          <KbStatusBoardStrip />

          {/* 전국 KB 매매 가격지수(콤보) + 상승률 지역 TOP — 2개 나란히 */}
          <div className="home-kb-chart-row">
            {/* 전국(kb_region.region_id=735, kb_region_code 0000000000) */}
            <KbTrendComboChart regionId={735} titleRegionName="전국" />
            <KbTopIndexChart titleRegionName="전국" />
          </div>

          {/* 지역 TOP10 랭킹 (투자금 / 상승·하락 × 주간·월간·6개월) */}
          <MainTopRankings />

          <div className="ranking-shortcut-row">
            <RankerComplexShortcutCard />
            <ComplexCompareShortcutCard />
          </div>
        </main>
      </div>
      {/* <WeeklyTopFiveComplexCard /> 임시 숨김 */}
    </div>
  );
}

export default RankingPage;
